import React from "react";
import Head from "next/head";
import CustomOG from "../customOG/CustomOG";
import {object, string} from "prop-types";
import CustomMeta from "../customMeta/CustomMeta";

export default function PageDescription({title, description, og = {}, extraMeta} = {}) {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description}/>
      </Head>
      <CustomOG {...og}/>
      {extraMeta ? <CustomMeta {...extraMeta}/> : null}
    </>
  );
}

PageDescription.propTypes = {
  title: string,
  description: string,
  og: object,
  extraMeta: object,
};
